import { Component, OnInit, ViewChild, ViewEncapsulation } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { NgbModal, NgbModalOptions } from "@ng-bootstrap/ng-bootstrap";
import { Store } from "@ngrx/store";
import { DatatableComponent, ColumnMode } from "@swimlane/ngx-datatable";
import { setPageNumber } from "app/App Store/actions/pageChange.actions";
import { AppState } from "app/App Store/state";
import { ApiService } from "app/shared/services/api.service";
import { environment } from "environments/environment";
import { NgxSpinnerService } from "ngx-spinner";
import { ToastrService } from "ngx-toastr";
import { Subscription } from "rxjs";
import swal from "sweetalert2";
import { DynamicDetailComponent } from "../../dynamic-detail/dynamic-detail.component";
import { Course } from "app/shared/models/course.model";
import {
  CdkDragDrop,
  moveItemInArray,
  transferArrayItem,
} from "@angular/cdk/drag-drop";
import { PopupModalComponent } from "app/shared/popup-modal/popup-modal.component";
import { EditSyllabusComponent } from "../edit-syllabus/edit-syllabus.component";
import { setCourseId } from "app/App Store/actions/courseChange.actions";
import { selectCourseId } from "app/App Store/selectors/courseChange.selectors";

@Component({
  selector: "app-class-template-list",
  templateUrl: "./class-template-list.component.html",
  styleUrls: ["./class-template-list.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class ClassTemplateListComponent implements OnInit {
  @ViewChild(DatatableComponent) table: DatatableComponent;
  @ViewChild("name") inputName;
  courses: Course[] = [];
  selectedCourse: Course = new Course();

  page = {
    pageNumber: 1,
    offset: 0,
    pageSize: 100,
    totalPages: 0,
  };
  // row data
  public rows = [];
  public filterRows = [];
  public ColumnMode = ColumnMode;
  public limitRef = 100;
  selectedValue = "";
  sections: any = [];
  isFilter: boolean = false;
  // column header
  public columns = [
    { name: "Class Name", prop: "title" },
    { name: "Actions", prop: "actions" },
  ];

  // private
  private tempData = [];
  imageUrl = environment.apiUrls.imageUrl;
  user_role: any;
  main_menu_id: any;
  activeTab: any;
  class_id: any;

  guideline_data: any;
  pageNumberSubscription: Subscription;
  select_Course;
  connectedOrNotConnected = [];
  isMulitConnect: boolean = false;
  isNotConnected: boolean = false;
  constructor(
    public apiService: ApiService,
    private spinner: NgxSpinnerService,
    public toastr: ToastrService,
    private modalService: NgbModal,
    private activerouter: ActivatedRoute,
    private route: Router,
    private store: Store<AppState>
  ) {
    this.user_role = JSON.parse(localStorage.getItem("user"));
    let setting_data = JSON.parse(localStorage.getItem("setting-record"));
    let key_data = setting_data.filter((item) => item.key == "Classes");
    this.guideline_data = key_data[0]?._id;

    this.store.select(selectCourseId)
    .subscribe(courseId => {
      this.select_Course = courseId;
    });
     this.activerouter.queryParamMap.subscribe((params) => {
      this.select_Course  = params.get("id");
    });
    this.activerouter.queryParamMap.subscribe((params) => {
      let page = +params.get("page");
      this.setPage(page);
    });
    this.pageNumberSubscription = this.store
      .select((state) => state.page.pageNumber)
      .subscribe((pageNumber) => {
        this.page.pageNumber = pageNumber;
        if (pageNumber !== undefined) {
          this.page.pageNumber = pageNumber - 1;
        }
        if (pageNumber === 0) this.page.pageNumber = 0;
      });
  }

  ngOnInit() {
      this.getCourses();
  }
  setPage(pageNumber: number) {
    this.store.dispatch(setPageNumber({ pageNumber }));
  }
  setSelectedCourse(courseId) {
    this.store.dispatch(setCourseId({ courseId }));
  }
  getCourses() {
    this.apiService.getAllCourses(1, 100).subscribe((res: any) => {
      const { data } = res;
      this.courses = data?.items;
      
      if (this.select_Course) {
        this.getclassTemplatesByCourseId(this.select_Course);
      }
      else {
        let default_id = this.courses.filter(
        (item) => item.title == "Fast-Track Placement Guide"
      );
      if (default_id) {
        this.select_Course = default_id[0]._id;
        this.getclassTemplatesByCourseId(this.select_Course);
      }
      else {
        this.selectedCourse = this.courses[0];
        const { _id } = this.selectedCourse;
        this.getclassTemplatesByCourseId(_id);
      }
      }
    });
  }
  getclassTemplatesByCourseId(id) {
    this.spinner.show(undefined, {
      type: "ball-triangle-path",
      size: "medium",
      bdColor: "rgba(0, 0, 0, 0.8)",
      color: "#fff",
      fullScreen: true,
    });
    this.apiService
      .getclassTemplatesByCourseId(1, 100, id)
      .subscribe((res: any) => {
        this.spinner.hide();
        const { data } = res;
        this.rows = data?.items;
        this.page.totalPages = res?.data?.totalCount;
      });
  }

  editClass(data) {
    this.route.navigate(["/classes/add-edit-session"], {
      queryParams: { id: data?._id },
    });
  }
  addClass(id) {
    this.route.navigate(["/classes/add-edit-session"], {
      queryParams: { courseId: id },
    });
  }
  pageChangeData(page: any) {
    this.route.navigate([], {
      relativeTo: this.activerouter,
      queryParams: { page: page.offset + 1 },
      queryParamsHandling: "merge", // keep existing query params
    });
    this.spinner.show(undefined, {
      type: "ball-triangle-path",
      size: "medium",
      bdColor: "rgba(0, 0, 0, 0.8)",
      color: "#fff",
      fullScreen: true,
    });
    this.apiService.getAllClassTemplate().subscribe((res: any) => {
      this.spinner.hide();
      this.setPage(page.offset + 1);
      this.rows = res.data.items;
      this.page.totalPages = res.data.totalCount;
    });
  }

  deleteClass(id, password) {
    this.apiService.deleteClassTemplate(id, password).subscribe((res: any) => {
      if (res.statusCode === 200) {
        swal.fire({
          icon: "success",
          title: "Deleted!",
          text: "Your file has been deleted.",
          customClass: {
            confirmButton: "btn btn-success",
          },
        });
        this.getclassTemplatesByCourseId(this.selectedCourse._id);
      } else {
        swal.fire({
          icon: "error",
          title: "Error!",
          text: `${res.error}`,
          customClass: {
            confirmButton: "btn btn-success",
          },
        });
      }
    });
  }

  // ================== Delete Alert ========================
  Delete(id: any) {
    this.class_id = id;
    swal
      .fire({
        text: "Please Enter Password",
        input: "password",
        showCancelButton: true,
      })
      .then((result) => {
        if (result.value) {
          this.deleteClass(this.class_id, result.value);
        } else if (result.dismiss === swal.DismissReason.cancel) {
          swal.fire({
            title: "Cancelled",
            icon: "error",
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
        }
      });
  }
  openDynamicModal(key_id: string) {
    const modalOptions: NgbModalOptions = {
      size: "lg", // 'sm', 'lg', or 'xl'
      backdrop: "static",
    };
    const modalRef = this.modalService.open(
      DynamicDetailComponent,
      modalOptions
    );
    modalRef.componentInstance.key_id = key_id;
  }
  selectCourse(course: any) {
    this.selectedCourse = course;
    const { _id } = this.selectedCourse;
    this.getclassTemplatesByCourseId(_id);
  }
  onDrop(event: CdkDragDrop<any>) {
    swal
      .fire({
        title: `Do you want to change?`,
        // html: 'You can use <b>bold text</b>, ' +
        //   '<a href="https://pixinvent.com/" target="_blank">links</a> ' +
        //   'and other HTML tags',
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        buttonsStyling: false,
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-danger ml-1",
        },
      })
      .then((result) => {
        if (result.isConfirmed) {
          if (event.previousContainer === event.container) {
            this.spinner.show(undefined, {
              type: "ball-triangle-path",
              size: "medium",
              bdColor: "rgba(0, 0, 0, 0.8)",
              color: "#fff",
              fullScreen: true,
            });
            // Reorder items within the same list
            let row = {
              templateFrom: this.rows[event.previousIndex]?._id
                ? this.rows[event.previousIndex]?._id
                : this.rows[event.previousIndex]?.id,
              templateTo: this.rows[event.currentIndex]?._id
                ? this.rows[event.currentIndex]?._id
                : this.rows[event.currentIndex]?.id,
              moveFrom: this.rows[event.previousIndex]?.order,
              moveTo: this.rows[event.currentIndex]?.order,
            };
            // Reorder sections
            // moveItemInArray(this.rows, event.previousIndex, event.currentIndex);
            this.apiService.changeClassTemplateOrder(row).subscribe(
              (res: any) => {
                if (res.statusCode === 200) {
                  this.getclassTemplatesByCourseId(this.selectedCourse._id);
                }
              },
              (error) => {
                this.spinner.hide();
              }
            );
          }
        }
      });
  }
  editSyllabus(data) {
    const modalRef = this.modalService.open(EditSyllabusComponent);
    modalRef.componentInstance.syllabusData = data; // Pass data to the component instance
    // Listen for the dataFetched event
    modalRef.componentInstance.dataFetched.subscribe((fetchedData) => {
      const { data } = fetchedData;
      this.selectedCourse._id = data.course_id;
      this.getclassTemplatesByCourseId(this.selectedCourse._id);
    });

    // Optionally handle the modal close event
    modalRef.result
      .then((result) => {
        console.log("Modal closed with:", result);
      })
      .catch((error) => {
        console.log("Modal dismissed with:", error);
      });
  }
  getCourseId(event) {
    this.selectedCourse = event;
    this.select_Course
    this.setSelectedCourse(this.select_Course)
    this.getclassTemplatesByCourseId(this.select_Course);
  }
  checkMultiConnectByCourseId(content, id) {
    this.spinner.show(undefined, {
      type: "ball-triangle-path",
      size: "medium",
      bdColor: "rgba(0, 0, 0, 0.8)",
      color: "#fff",
      fullScreen: true,
    });

    this.apiService.checkMultiConnect(id).subscribe((res: any) => {
      this.spinner.hide();
      if (res?.isSuccess) {
        this.isMulitConnect = true;
        this.isNotConnected = false
        const modalOptions: NgbModalOptions = {
          size: "lg",
        };
        const modalRef = this.modalService.open(content, modalOptions);
        modalRef.result.then(
          (result) => {
            // console.log(`Modal closed with result: ${result}`);
          },
          (reason) => {}
        );
        this.connectedOrNotConnected = res?.data;
      } else {
        swal.fire({
          title: "Error",
          text: `${res?.error}`,
          icon: "error",
          customClass: {
            confirmButton: "btn btn-success",
          },
        });
      }
    });
  }
  checkNotConnectByCourseId(content, id) {
    this.spinner.show(undefined, {
      type: "ball-triangle-path",
      size: "medium",
      bdColor: "rgba(0, 0, 0, 0.8)",
      color: "#fff",
      fullScreen: true,
    });
    this.isNotConnected = true;
    this.apiService.checkNotConnect(id).subscribe((res: any) => {
      this.spinner.hide();
      if (res?.isSuccess) {
        this.isNotConnected = true;
        this.isMulitConnect = false
        const modalOptions: NgbModalOptions = {
          size: "lg",
        };
        const modalRef = this.modalService.open(content, modalOptions);
        modalRef.result.then(
          (result) => {
            // console.log(`Modal closed with result: ${result}`);
          },
          (reason) => {}
        );
        this.connectedOrNotConnected = res?.data;
      } else {
        swal.fire({
          title: "Error",
          text: `${res?.error}`,
          icon: "error",
          customClass: {
            confirmButton: "btn btn-success",
          },
        });
      }
    });
  }
}
